/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { HlpListItemDto, UserListItemDto } from '@gh/builder-shared-data';
import { ID } from '@gh/common-shared-data';

export const IMAGE_TYPES = {
  facade: 1,
  floorPlan: 2,
  image: 3,
};

export type HlpListItem = HlpListItemDto & {
  masterZoneId?: ID;
  officeId?: ID;
};

export type SalespersonSelectItem = {
  id: ID;
  name: string;
  status?: string;
};

export type UserListItem = UserListItemDto;

export const isSalespersonSelectItemInactive = ({ status }: SalespersonSelectItem): boolean =>
  status === 'INACTIVE' || status === 'DELETED';

export const salespersonSelectItemMapper =
  ({ userId, userName, status }: UserListItem) => ({ id: userId, name: userName, status });
export const ALL_SALESPERSON_SELECT_VALUE = '_All';
